import { useMemo } from 'react';

import {
  CalendarDate,
  DateValue,
  parseDate,
} from '@internationalized/date';

import { NcDatePicker } from '../NcDatePicker';

export type ExpirationFieldPropsT = {
  max: CalendarDate;
  min: CalendarDate;
  onChange: (date: DateValue | null) => void;
  errorMessage?: string;
  value?: string;
};

// Separate component so useMemo can stabilise the CalendarDate reference between parent
// renders, preventing NcDatePicker's defaultValue useEffect from resetting user input.
export const ExpirationField = ({
  errorMessage,
  max,
  min,
  onChange,
  value,
}: ExpirationFieldPropsT) => {
  const dateValue = useMemo(
    () => (value && /^\d{4}-\d{2}$/.test(value) ? parseDate(`${value}-01`) : undefined),
    [value],
  );

  return (
    <NcDatePicker
      defaultValue={dateValue}
      errorMessage={errorMessage}
      granularity="month"
      hideCalendar
      id="benefits-expiration"
      label={<span className="form-label">Expiration Month and Year</span>}
      max={max}
      min={min}
      onChange={onChange}
    />
  );
};
